import { render, staticRenderFns } from "./TransporterContractList.vue?vue&type=template&id=27019b09"
import script from "./TransporterContractList.vue?vue&type=script&lang=js"
export * from "./TransporterContractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports